<dv-erweiterte-beduerfnisse-bestaetigung
    [angebotTypSig]="angebotTyp"
    [erweiterteBetreuungJA]="erweiterteBetreuungJA"
    [einstellungenSig]="einstellungen"
    [readOnly]="readOnly"
    [hoehereBeitraegeTyp]="hoehereBeitraegeTyp"
></dv-erweiterte-beduerfnisse-bestaetigung>
